package com.dwarshb.bms

import androidx.compose.runtime.mutableStateMapOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.dwarshb.firebase.Firebase
import com.dwarshb.firebase.FirebaseDatabase
import com.dwarshb.firebase.onCompletion
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.isActive
import kotlinx.coroutines.launch
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.decodeFromJsonElement
import kotlinx.serialization.json.jsonArray
import kotlinx.serialization.json.jsonObject
import kotlin.math.abs
import kotlin.random.Random

class TripViewModel : ViewModel() {

    val json = Json { ignoreUnknownKeys = true }

    private val _bookings = MutableStateFlow<Map<String, Booking>>(mutableMapOf())
    val bookings = _bookings.asStateFlow()

    val firebaseDatabase = FirebaseDatabase()

    fun createTrip(trip: Trip, onResult:(String)->Unit) {
        var tripMap = HashMap<String,Any>()
        var code = "${trip.tripName}-${trip.departureLocation}-${trip.arrivalLocation}"
            .hashCode()
        trip.id = abs(code).toString().take(6)
        tripMap["organizerId"] = trip.organizer.uid
        viewModelScope.launch {
            firebaseDatabase.patchFirebaseDatabase(
                listOf("trips",trip.id),
                tripMap,
                object : onCompletion<String> {
                    override fun onSuccess(T: String) {
                        onResult(trip.id)
                    }

                    override fun onError(e: Exception) {
                        e.printStackTrace()
                        onResult(e.message.toString())
                    }
                })
            tripMap = HashMap<String,Any>()
            tripMap[trip.tripName] = trip
            firebaseDatabase.patchFirebaseDatabase(
                listOf("trips",trip.id),
                tripMap,
                object : onCompletion<String>{
                    override fun onSuccess(T: String) {
                        onResult(trip.id)
                    }

                    override fun onError(e: Exception) {
                        e.printStackTrace()
                        onResult(e.message.toString())
                    }
                })
        }

    }

    fun getAppUserTrips(onResult: (Trip?) -> Unit) {
        val currentUser = Firebase.getCurrentUser()
        var path = listOf("trips")
        viewModelScope.launch {
            firebaseDatabase.readFirebaseDatabase(path,
                "orderBy=\"organizerId\"&equalTo=\"${currentUser?.uid}\"",
                object : onCompletion<String>{
                    override fun onSuccess(T: String) {
                        val trips = Json.parseToJsonElement(T).jsonObject
                        for (trip in trips) {
                            for (tripDetails in trip.value.jsonObject) {
                                if (tripDetails.key != "organizerId") {
                                    val details = json.decodeFromJsonElement<Trip>(
                                        tripDetails.value
                                    )
                                    onResult(details)
                                }
                            }
                        }
                    }

                    override fun onError(e: Exception) {
                        e.printStackTrace()
                        onResult(null)
                    }
                })
        }
    }

    fun getAppUser(onResult: (AppUser?) -> Unit) {
        val currentUser = Firebase.getCurrentUser()
        var path = listOf("users")
        viewModelScope.launch {
            firebaseDatabase.readFirebaseDatabase(path,
                "orderBy=\"uid\"&equalTo=\"${currentUser?.uid}\"",
                object : onCompletion<String> {
                    override fun onSuccess(T: String) {
                        val user = Json.parseToJsonElement(T).jsonObject[currentUser?.uid]
                        var appUser = user?.let {
                            json.decodeFromJsonElement<AppUser>(
                                it
                            )
                        }
                        onResult(appUser)
                    }

                    override fun onError(e: Exception) {
                        e.printStackTrace()
                        onResult(null)
                    }
                })
        }
    }

    fun getTrip(code: String, onResult: (Trip?) -> Unit) {
        val path = listOf("trips",code)
        viewModelScope.launch {
            firebaseDatabase.readFirebaseDatabase(path,"",
                object : onCompletion<String> {
                    override fun onSuccess(T: String) {
                        val trips = Json.parseToJsonElement(T).jsonObject
                        for(tripName in trips) {
                            if (tripName.key != "organizerId") {
                                println(tripName.value)
                                var trip = json.decodeFromString<Trip>(
                                    tripName.value.toString()
                                )
                                onResult(trip)
                            }
                        }
                    }

                    override fun onError(e: Exception) {
                        e.printStackTrace()
                        onResult(null)
                    }
                })
        }
    }

    fun requestBooking(booking: Booking,onResult: (Booking?) -> Unit) {
        val path = listOf("reservations",booking.tripId)
        val map = HashMap<String,Any>()
        map[booking.phoneNumber] = booking
        viewModelScope.launch {
            firebaseDatabase.patchFirebaseDatabase(path,map,
                object : onCompletion<String> {
                    override fun onSuccess(T: String) {
                        onResult(booking)
                    }

                    override fun onError(e: Exception) {
                        e.printStackTrace()
                        onResult(null)
                    }
                })
        }
    }

    fun getReservations(id: String) {
        val path = listOf("reservations",id)
        viewModelScope.launch {
                firebaseDatabase.readFirebaseDatabase(path, "", object : onCompletion<String> {
                    override fun onSuccess(T: String) {
                        println(T)
                        if(T!="null") {
                            val reservations = json.parseToJsonElement(T).jsonObject
                            for (booking in reservations) {
                                println(booking.value)
                                val updatedMap = _bookings.value.toMutableMap()
                                updatedMap[booking.key] =
                                    json.decodeFromJsonElement<Booking>(booking.value)
                                _bookings.value = updatedMap
                            }
                        }
                    }

                    override fun onError(e: Exception) {
                        e.printStackTrace()
                    }
                })
        }
    }

    fun getYourTicket(code: String, number: Any, onResult: (Booking?) -> Unit) {
        val path = listOf("reservations",code)
        viewModelScope.launch {
            firebaseDatabase.readFirebaseDatabase(path,
                "orderBy=\"phoneNumber\"&equalTo=\"$number\"",
                object : onCompletion<String> {
                    override fun onSuccess(t: String) {
                        println(t)
                        val booking = json.parseToJsonElement(t)
                        for (details in booking.jsonObject) {
                            onResult(json.decodeFromJsonElement<Booking>(details.value))
                        }
                    }

                    override fun onError(e: Exception) {
                        e.printStackTrace()
                        onResult(null)
                    }
                })
        }
    }

    fun deleteReservation(booking: Booking) {
        val path = listOf("reservations",booking.tripId,booking.phoneNumber)
        viewModelScope.launch {
            firebaseDatabase.deleteFirebaseDatabase(path,object : onCompletion<String>{
                override fun onSuccess(t: String) {
                    val updatedMap = _bookings.value.toMutableMap()
                    updatedMap.remove(booking.phoneNumber)
                    _bookings.value = updatedMap
                }

                override fun onError(e: Exception) {
                   e.printStackTrace()
                }
            })
        }
    }
}